import { Consultation, Weight } from '@app/core/models';
import { createAction, props } from '@ngrx/store';

/**
 * Get consultations actions
 */
/**
 * Action to load consultations with renal information
 */
export const getConsultationsWithoutVisit = createAction('[Pet] Get Consultations Without Visit', props<{ patientId: string }>());
export const getConsultationsWithoutVisitSuccess = createAction(
  '[Pet] Get Consultations Without Visit Success',
  props<{ consultations: Consultation[] }>(),
);

export const setGrowthChartNotSavedPastWeights = createAction('[Pet] Set Growth Chart Not Saved Past Weights', props<{ weight: Weight }>());

export const setGrowthChart = createAction('[Pet] Set Growth Chart', props<{ chartImage: string; chartWeights: Weight[] }>());

export const resetGrowthChart = createAction('[Pet] Reset Growth Chart');

export const resetState = createAction('[Pet] Reset State');
